<h3-tool-mode
  *ngIf="buttons.length"
  [buttons]="buttons"
  [tool]="tool"
  eventBucket="adjustment"
  [ngModel]="tool.editMode$ | async"
  (ngModelChange)="tool.setEditModeFromUser($event)"
></h3-tool-mode>

<ng-template #addIcon>
  <fa-layers [fixedWidth]="true">
    <fa-icon [icon]="faPlus" transform="shrink-8 up-10 left-6"></fa-icon>
    <fa-icon [icon]="faPenNib"></fa-icon>
  </fa-layers>
</ng-template>

<ng-template #clickyIcon>
  <fa-layers [fixedWidth]="true">
    <fa-icon
      class="dot"
      [icon]="faCircle"
      transform="shrink-8 up-10 left-6"
    ></fa-icon>
    <fa-icon [icon]="faMousePointer"></fa-icon>
    <fa-icon
      class="bolt"
      [icon]="faBolt"
      transform="shrink-2 up-8 right-14"
    ></fa-icon>
  </fa-layers>
</ng-template>
